import styled from '@emotion/styled'
import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Growth Masters Curriculum`,
  description: `Each on-demand lesson is led by a product or growth expert and goes deep on a specific topic.`,
}

const GrowthMastersCurriculum: FC = () => {
  return (
    <StyledSectionBase variant="centered">
      <StyledSectionCopy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h1" variant="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="h2">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </StyledSectionCopy>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 844px;
`

export default GrowthMastersCurriculum
